import { styled } from 'styled-components'
import { over } from 'utils'

export const Paragraph = styled.div`
	width: 100%;
	${over('md')} {
		width: 50%;
	}
`
